module.exports = __webpack_public_path__ + "img/symbol_kutschemitpferd.82c8074.webp";